import {AppActions, useAppContext} from "../../Context/ProjectContextV2";
import {Table, Tag, Typography} from "antd";
import React, {useEffect, useState} from "react";
import AppColor from "./AppColor";

export default function SelectPlanV2({type}) {
    const {appContext, selection, dispatchProject} = useAppContext()

    const loadProject = (id) => {
        const project = appContext?.projects?.find(x => x?.id === id)
        if(project) {
            const plan = project?.projectFiles[0]
            const _selection = {
                ...selection,
                [type]: {
                    project,
                    plan,
                    river: plan?.rivers[0]
                }
            }

            dispatchProject({
                type: AppActions.SET_PROJECT_SELECTION,
                data: {
                    selection: _selection
                }
            })
        }
    }

    return (
        <div style={{display: 'flex', alignItems: 'start', gap: 8}}>
            <Table
                pagination={false}
                style={{width: 400}}
                size={'small'}
                dataSource={appContext?.projects}
                rowKey={'id'}
                columns={[
                    {
                        key: '1',
                        dataIndex: '2',
                        title: 'Projects',
                        render: (text, record) => (
                            <Typography.Link
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 8,
                                    color: selection[type]?.project?.id === record?.id ? AppColor.mainColor : 'black',
                                    fontWeight: selection[type]?.project?.id === record?.id ? 'bold' : '',
                                    cursor: 'pointer'
                                }}
                                onClick={() => loadProject(record?.id)}
                            >
                                <div style={{minWidth:300}}>{record?.information?.title}{selection[type]?.project?.id === record?.id ? <>&#x2022;</> : ''}</div> <Tag>{record?.modelType || 'Model A'}</Tag>
                            </Typography.Link>
                        )
                    }
                ]}
            />
            <Table
                pagination={false}
                style={{width: 300}}
                size={'small'}
                dataSource={selection[type]?.project?.projectFiles || []}
                rowKey={'id'}
                columns={[
                    {
                        key: '1',
                        dataIndex: '2',
                        title: `Plans: ${selection[type]?.project?.information?.title}`,
                        render: (text, record) => (
                            <>
                                <Typography.Link
                                    onClick={() => {
                                        dispatchProject({
                                            type: AppActions.SET_PROJECT_SELECTION,
                                            data: {
                                                selection: {
                                                    ...selection,
                                                    [type]: {
                                                        project: selection[type].project,
                                                        plan: {...record},
                                                        river: record?.rivers[0]
                                                    }
                                                }
                                            }
                                        })
                                    }}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 8,
                                        color: selection[type]?.plan?.id === record?.id ? AppColor.mainColor : 'black',
                                        fontWeight: selection[type]?.plan?.id === record?.id ? 'bold' : '',
                                        cursor: 'pointer'
                                    }}
                                >
                                    {record?.type} {selection[type]?.plan?.id === record?.id ? <>&#x2022;</> : ''}
                                </Typography.Link>
                                <span style={{color: 'black'}}>{record?.plan?.fileName}</span>
                            </>
                        )
                    }
                ]}
            />
            {
                selection[type]?.plan?.rivers?.length > 0 && (
                    <Table
                        pagination={false}
                        style={{width: 300}}
                        size={'small'}
                        dataSource={selection[type]?.plan?.rivers || []}
                        rowKey={'id'}
                        columns={[
                            {
                                key: '1',
                                dataIndex: '2',
                                title: `Rivers: ${selection[type]?.plan?.type}`,
                                render: (text, record) => (
                                    <Typography.Link
                                        onClick={() => {
                                            dispatchProject({
                                                type: AppActions.SET_PROJECT_SELECTION,
                                                data: {
                                                    selection: {
                                                        ...selection,
                                                        [type]: {
                                                            project: selection[type].project,
                                                            plan: selection[type].plan,
                                                            river: {...record}
                                                        }
                                                    }
                                                }
                                            })
                                        }}
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 8,
                                            color: AppColor.mainColor,
                                            fontWeight: selection[type]?.river?.key === record?.key ? 'bold' : '',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        {record?.reach} - {record?.river}  {selection[type]?.river?.key === record?.key ? <>&#x2022;</> : ''}
                                    </Typography.Link>
                                )
                            }
                        ]}
                    />
                )
            }
        </div>
    )
}